import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ButtonPrimary from "../../../Common/Buttons/ButtonPrimary";
import BaseCard from "../../../Common/Cards/BaseCard";
import Select from "../../../Common/Forms/Select";
import { Teacher } from "../../../api/teacher";
import { Class } from "../../../api/class";

export function ManageTeachersDialog() {
  const [allTeachers, setAllTeachers] = useState<
    Awaited<ReturnType<typeof Teacher.getAllTeachers>>
  >([]);
  const [allClasses, setAllClasses] = useState<
    Awaited<ReturnType<typeof Class.getAllClasses>>
  >([]);

  const [curTeacherId, setCurTeacherId] = useState<number>(-1);
  const [curClassId, setCurClassId] = useState<number>(-1);

  useEffect(() => {
    const run = async () => {
      const newAllTeachers = await Teacher.getAllTeachers();
      setAllTeachers(newAllTeachers);
      setCurTeacherId(newAllTeachers[0].id);
      const newAllClasses = await Class.getAllClasses();
      setAllClasses(newAllClasses);
      setCurClassId(newAllClasses[0].class.id ?? -1);
    };

    run();
  }, []);

  const getRelevantClass = () => {
    return allClasses.find((myClass) => myClass.class.id === curClassId);
  };

  const addToClass = async () => {
    if (curTeacherId === -1 || curClassId === -1) {
      throw new Error("Teacher or Class not Properly Selected");
    }

    await getRelevantClass()?.addTeacher(curTeacherId);
  };
  const removeFromClass = async () => {
    if (curTeacherId === -1 || curClassId === -1) {
      throw new Error("Teacher or Class not Properly Selected");
    }

    await getRelevantClass()?.removeTeacher(curTeacherId);
  };

  // const teachers =
  return (
    <BaseCard title="Manage Teachers">
      <div className="w-full gap-1 flex flex-col">
        <p>Teacher</p>
        <Select
          icon="user"
          placeholder="Select Teacher"
          options={allTeachers.map((teacher) => ({
            value: teacher.id,
            label: teacher.staffDetail?.displayName ?? "",
          }))}
          onChange={(newVal) => {
            setCurTeacherId(+newVal);
          }} />
      </div>
      <div className="w-full gap-1 flex flex-col">
        <p>Class</p>
        <Select
          icon="book"
          placeholder="Select Class"
          options={allClasses.map((myClass) => ({
            value: myClass.class.id ?? -1,
            label: String(myClass.class.id) ?? "",
          }))}
          onChange={(newVal) => {
            setCurClassId(+newVal);
          }} />
      </div>
      <ButtonPrimary
        onClick={() => toast.promise(addToClass(), {
          success: "Added to class",
          loading: "Adding to class",
          error: (e) => e.message,
        })}
      >
        Add to Class
      </ButtonPrimary>
      <ButtonPrimary
        onClick={() => toast.promise(removeFromClass(), {
          success: "Removed from class",
          loading: "Removing from class",
          error: (e) => e.message,
        })}
      >
        Remove from Class
      </ButtonPrimary>
    </BaseCard>
  );
}
